export const API_URL = process.env.REACT_APP_API_URL;
export const HOST =
  process.env.NODE_ENV !== 'development'
    ? API_URL
    : 'https://pella-media-be.pella-testing.g43labs.net/';

export const BASE_URL = `${HOST}api/v1/`;

export const OKTA_AUTH_TOKENS = `${BASE_URL}okta/authorization-code/callback`;
export const AUTH_BASE = `${BASE_URL}auth`;
export const USER_DATA = `${AUTH_BASE}/user-details`;
export const REFRESH_TOKEN = `${AUTH_BASE}/refresh-token`;

export const LOGIN = `${AUTH_BASE}/login`;
export const LOGOUT = `${AUTH_BASE}/logout`;
export const FORGOT_PASSWORD = `${AUTH_BASE}/password/reset/request`;
export const RESET_PASSWORD = `${AUTH_BASE}/password/reset/confirm`;

export const QUERY = '/api/v1/query';
export const COMPONENT_QUERY = '/api/v2/query';
export const GET_PROMOTION = (id) => `/api/v1/promotion?promotion_id=${id}`;
export const GET_PRODUCT_LIST = '/api/v1/promotion/products/list';
export const GET_OFFER_LIST = '/api/v1/offer/list';
export const SAVE_PROMOTION = '/api/v1/promotion';
export const GENERATE_PREVIEW = '/api/v1/offer/generate';
export const CREATIVE_API = '/api/v1/creatives';
export const COMPONENT_QUERY_COMPARE = '/api/v2/query/compare';
export const DOWNLOAD_URL = `/api/v1/report/download`;

// Email Ad Validation APIs
export const EMAIL_AD_VALIDATION_RUNS = '/api/v1/email-ad-validation-runs/';
export const EMAIL_AD_VALIDATION_RERUN = (runId) =>
  `/api/v1/email-ad-validation-runs/${runId}/rerun/`;
export const EMAIL_AD_VALIDATION_DELETE = (runId) => `/api/v1/email-ad-validation-runs/${runId}/`;
